module.exports = __webpack_public_path__ + "assets/a1e448e6df3a7450c888f14de793f8b7.woff2";